import React from 'react';

import { wordpressImgToImgixURL } from 'Utilities';

import { Content } from 'LegacySBCRA/Content/Content';

import ContentBody from '../ContentBody';
import type { ACFType } from '../UlezPage.types';

import styles from './Section.scss';

const Section = ({ acf }: ACFType) => {
  if (!acf) {
    return null;
  }

  const imgSrc = acf.section_one_image_area;

  return (
    <div className={styles.contentWrapper}>
      <Content className={styles.content} element="section">
        {(imgSrc) ? (
          <img
            alt={acf.section_one_image_area_alt as string}
            className={styles.illustration}
            height="578"
            loading="lazy"
            src={`${wordpressImgToImgixURL(imgSrc)}`}
            width="288"
          />
        ) : (null)}
        <div className={styles.info}>
          <h3>{acf.section_one_title as string}</h3>
          <ContentBody
            body={acf.section_one_body_area as string}
          />
        </div>
      </Content>
    </div>
  );
};

export default Section;
